<script setup lang="ts">
import type { PropertyAreaProps } from '.';
import type IntervalInput from '~/components/IntervalInput/Input.vue';

import { propertyAreaInputVariants } from '.';

const props = withDefaults(defineProps<PropertyAreaProps>(), {
	variant: 'primary',
	showActions: false,
	closeOnApply: false
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');

const intervalInputRef = ref<InstanceType<typeof IntervalInput> | null>(null);

const emit = defineEmits<{
	apply: [focusNext?: boolean];
	clear: [];
	'update:range': [
		min: number | null | undefined,
		max: number | null | undefined
	];
}>();

function handleRangeUpdate(
	newMin: number | null | undefined,
	newMax: number | null | undefined
) {
	emit('update:range', newMin, newMax);
}

function handleApply(focusNext?: boolean) {
	if (focusNext) {
		emit('apply', true);
		return;
	}

	emit('apply');
}

defineExpose({
	focusFirstInputWhenReady: () =>
		intervalInputRef.value?.focusFirstInputWhenReady()
});
</script>

<template>
	<IntervalInput
		ref="intervalInputRef"
		v-model:min="min"
		v-model:max="max"
		title="Área útil"
		unit="area"
		min-label="Área mínima"
		max-label="Área máxima"
		update-on="blur"
		:show-actions="props.showActions"
		:close-on-apply="props.closeOnApply"
		filter-name="area"
		:variant="props.variant"
		:input-classes="propertyAreaInputVariants({ variant: props.variant })"
		@apply="handleApply"
		@clear="emit('clear')"
		@update:range="handleRangeUpdate"
	/>
</template>
